<!--
 * @Author: 
 * @Date: 2024-03-26 19:15:19
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-08 13:54:56
 * @Description: 这是自动模式的输入面板（窗口） 组件名： <CasinoAutoSection
9位数数字：0.0000001 BTC === 0.0608CNY 
9位数数字：123456789 === 1 亿多
所以为输入框长度上限定为9位，足够 
-->
<template>
    <ModalTitle
        v-model="dialogVisible"
        :backdrop="false"
        :showCloseIcon="false"
        :containerClass="'!w-[350px] max-w-[96vw]'"
        v-bind="$attrs"
    >
        <template #header>
            <span class="dialog-header-text"
                :title="t.AutoDialogTitle"
            >
                {{ t.AutoDialogTitle }}
            </span>
            <!-- ↓ 点击弹出提示窗口 -->
            <QIcon name="help"
                class="text-[#93acd3] cursor-pointer"
                @click="() => isShowAutoModeModal = true"
            />
        </template>
        <!-- 
            ↑ 标题
            ↓ 表单
        -->
        <table class="form-table">
            <tbody>
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.BetAmount }}
                    </td>
                    <td>
                        <Input placeholder="0"
                            :min="0"
                            :max="maxValue"
                            inputmode="decimal"
                            maxlength="9"
                            v-model="oAutoForm.amount"
                            :containerCalss="[inputStyle, widthStyle]" 
                            :disabled="isSubmiting || (gameName == 'rouletteGame')" 
                            @blur="onInputBlurChangeBetAmount"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                        >
                            <template v-slot:prepend>
                                <CurrentCoin />
                            </template>
                        </Input>
                    </td>
                </tr>
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.NUMBER_OF_BETS }}
                    </td>
                    <td>
                        <Input placeholder="0"
                            min="0"
                            type="number"
                            inputmode="numeric"
                            v-model="oAutoForm.number"
                            :containerCalss="[inputStyle, widthStyle]" 
                            :disabled="isSubmiting"
                            maxlength="6"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                        >
                            <template v-slot:append
                                v-if="!oAutoForm.number"
                            >
                                <div class="text-white">∞</div>
                            </template>
                        </Input>
                    </td>
                </tr>
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.STOP_ON_PROFIT }}
                    </td>
                    <td>
                        <Input placeholder="0"
                            inputmode="decimal"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                            v-model="oAutoForm.stopOnProfit"
                            :containerCalss="[inputStyle, widthStyle]"
                            :disabled="isSubmiting"
                            maxlength="9"
                        >
                            <template v-slot:prepend>
                                <CurrentCoin />
                            </template>
                        </Input>
                    </td>
                </tr>
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.STOP_ON_LOSS }}
                    </td>
                    <td>
                        <Input placeholder="0"
                            inputmode="decimal"
                            v-model="oAutoForm.stopOnLoss"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                            :containerCalss="[inputStyle, widthStyle]" 
                            :disabled="isSubmiting"
                            maxlength="9"
                        >
                            <template v-slot:prepend>
                                <CurrentCoin />
                            </template>
                        </Input>
                    </td>
                </tr>
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.MAX_BET_AMOUNT }}
                    </td>
                    <td>
                        <Input placeholder="0"
                            inputmode="decimal"
                            v-model="oAutoForm.maxBetAmount"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                            :containerCalss="[inputStyle, widthStyle]"
                            :disabled="isSubmiting"
                            maxlength="9"
                        >
                            <template v-slot:prepend>
                                <CurrentCoin />
                            </template>
                        </Input>
                    </td>
                </tr>
                <!-- 
                    说明：以下的涨跌只能输入整数，
                    即，涨跌最小步幅是 1% 
                -->
                <!-- ↓ “赢” 时涨跌控制 -->
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.ON_WIN }}
                    </td>
                    <td class="radio-group ">
                        <span>
                            <q-radio v-model="oLocalForm.onWinReset" :val="1" :label="t.Reset" />
                        </span>
                        <span>
                            <q-radio v-model="oLocalForm.onWinReset" :val="0" :label="t.Increase" />
                            <Input
                                placeholder="0"
                                type="number"
                                inputmode="numeric"
                                min="0"
                                class=""
                                v-model="oAutoForm.onWin"
                                @click="cancelReset('onWinReset')"
                                :containerCalss="[inputStyle, widthStyle,]"
                                :disabled="isSubmiting"
                                maxlength="6"
                                @keypress="onlyNumberPress"
                                @input="onlyNumberChange"
                            >
                                <template v-slot:append>
                                    <div class="text-white text-xs">%</div>
                                </template>
                            </Input>
                        </span>
                    </td>
                </tr>
                <!-- ↓ “输” 时涨跌控制 --> 
                <tr class="item" :class="widthStyle">
                    <td class="label text-xs font-semibold">
                        {{ t.ON_LOSS }}
                    </td>
                    <td class="radio-group " >
                        <span>
                            <q-radio v-model="oLocalForm.onLossReset" :val="1" :label="t.Reset" />
                        </span>
                        <span>
                            <q-radio v-model="oLocalForm.onLossReset" :val="0" :label="t.Increase" />
                            <Input
                                placeholder="0"
                                type="number"
                                inputmode="numeric"
                                min="0"
                                class=""
                                @click="cancelReset('onLossReset')"
                                v-model="oAutoForm.onLoss"
                                :containerCalss="[inputStyle, widthStyle,]"
                                :disabled="isSubmiting"
                                maxlength="6"
                                @keypress="onlyNumberPress"
                                @input="onlyNumberChange"
                            >
                                <template v-slot:append>
                                    <div class="text-white text-xs">%</div>
                                </template>
                            </Input>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 最下方按钮 -->
        <template #footer>
            <Button
                class="secondaryContained text-white h-[45px] flex-1"
                @click="toCloseDialog(false)"
            >
                {{ t.Cancel }}
            </Button>
            <Button
                class="primaryContained text-white  h-[45px] flex-1"
                @click="toCloseDialog(true)"
            >
                {{ t.commonInfo.confirmBtn }}
            </Button>
        </template>
    </ModalTitle>

    <!-- ↓ 窗口02，自动模式提示框 -->
    <ModalAutoModeReminder
        v-model="isShowAutoModeModal"
    />
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import betHelper from '~/common/js/betHelper';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import { onlyNumberChange, onlyNumberPress } from '~/utils/input';
import { useUserStore } from '@/stores/user';

defineOptions({ 
    inheritAttrs: false
});

const props = defineProps({
    isFast: {
        type: Boolean,
    },
    isSubmiting: {
        type: Boolean,
    },
    amount: {
        type: [Number, String],
    },
    isAuto: { // 似乎没什么作用 
        type: Boolean,
    },
    gameName: {
        type: String,
    },
});

const t = useTranslation();
const autoOption = useAutoOptionStore();
const oAutoForm = reactive({
    amount: '0.00',
    ...autoOption.$state,
});
const dialogVisible = ref(false);
const inputStyle = 'bg-[#161f2c] rounded-xl h-[40px] border-[#55657e] text-lg font-bold'; 
const widthStyle = '';
const isShowAutoModeModal = ref(false);
const emit = defineEmits(['update:amount']);
const userStore = useUserStore();

// ↓ 本地表单对象，用于控制 <q-radio/> 的状态并同步到 oAutoForm 中 
// ↓ 因为 <q-radio/> 不接受布尔值参数，所以有此一步中转  
const oLocalForm = reactive({
    onWinReset: oAutoForm.onWinReset ? 1 : 0,
    onLossReset: oAutoForm.onLossReset ? 1 : 0,
});

watch(
    ()=>oLocalForm,
    (oNewForm)=>{
        Object.assign(oAutoForm, {
            onWinReset: !!oNewForm.onWinReset,
            onLossReset: !!oNewForm.onLossReset,
        });
    },
    {deep: true},
);

watch(
    ()=>oAutoForm,
    (oNewForm)=>{
        Object.assign(oLocalForm, {
            onWinReset: oNewForm.onWinReset ? 1 : 0,
            onLossReset: oNewForm.onLossReset ? 1 : 0,
        });
    },
    {deep: true},
);

// ↓ 下注金额上限 
const maxValue = computed(() => {
    return betHelper.onMaxClick({
        currentBalance: userStore.oNowCurrency.balance,
        maxBetAmount: betHelper.getMaxBetAmout(),
    })[0];
});

// ↓输入框 blur 事件 
const onInputBlurChangeBetAmount = (ev: any) => {
    const [sFinalValue, toast] = betHelper.fixAmountValue(
        ev.target.value,
    );
    showToastIfNeeded(toast);
    ev.target.value = sFinalValue;
    oAutoForm.amount = sFinalValue;
};

// ↓ 取消 reset 
type ResetKey = 'onLossReset' | 'onWinReset';
const cancelReset = (sKey:ResetKey) => {
    oAutoForm[sKey] = false;
}

// ↓ 关闭窗口
const toCloseDialog = (toSave=false)=>{
    dialogVisible.value = false; 
    if (toSave) {
        autoOption.setState(oAutoForm);
        console.log('Auto plan ↓\n', deepCopy(oAutoForm));
        emit('update:amount', Number(oAutoForm.amount));
    }
}

// ↓ 控制窗口可见性 
const switchAutoDialogVisible = (bVisible)=>{
    dialogVisible.value = !!bVisible;
    if (!bVisible) return; // 关闭窗口时不再向下执行
    // ↓ 以下为开窗专用事件 ----------------------------
    Object.assign(oAutoForm, autoOption.$state);
    const sAmount = getFixed(Number(props.amount));
    oAutoForm.amount = sAmount;
}

defineExpose({
    switchAutoDialogVisible,
});


</script>


<style scoped lang="scss">
.dialog-header-text{
    flex-grow: 0;
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    line-height: 2.5rem;
    font-size: 22px; // 24px;
}

.form-table{
    color: white;
    tr{
        + tr td{
            padding-top: 10px;
        }
    }
    td.label{
        padding-right: 16px;
        white-space: nowrap;
    }
    .radio-group {
        .q-radio{
            margin-right: 10px;
        }
        & > span{
            display: flex;
            margin-left: -8px; 
        }
        &:deep(){
            .q-radio__inner{
                font-size: 33px;
            }
            .q-radio__label{
                white-space: nowrap;
            }
            .q-radio[aria-checked="false"]{
                .q-radio__bg{
                    color: #55657E;
                }
            }
        }
    }
}

</style>
